import apiEndPoints from 'common/apiEndPoints';
import { performRequestSecond } from 'common/apiHandler';
import { getTenantDetails } from 'utils/utils';

export const listAnnouncements = (pageLimit = 20, nextToken = '') => {
  const [tenantId] = getTenantDetails();
  const method = apiEndPoints.methodType.GET;
  const url = `${apiEndPoints.listAnnouncements}?tenant_id=${tenantId}&limit=${pageLimit}&pagination_token=${nextToken}`;
  return performRequestSecond(method, url, '', '', true, true);
};

export const createAnnouncement = (data) => {
  const method = apiEndPoints.methodType.POST;
  return performRequestSecond(method, apiEndPoints.createAnnouncement, data, '', true, true);
};

export const dismissAnnouncement = (announcement_id) => {
  const [tenantId] = getTenantDetails();
  const method = apiEndPoints.methodType.POST;
  const url = `${apiEndPoints.dismissAnnouncement}?tenant_id=${tenantId}`;
  return performRequestSecond(method, url, { announcement_id }, '', true, true);
};
